const MAKERWORLD_HOST_PATTERN = /(^|\.)makerworld\.com$/i;
const MAKERWORLD_MODEL_PATH = /\/models\/\d+-/i;

export function isValidMakerworldModelUrl(raw) {
  const value = String(raw || '').trim();
  if (!value) return false;
  try {
    const withScheme = value.startsWith('http://') || value.startsWith('https://') ? value : `https://${value}`;
    const parsed = new URL(withScheme);
    if (!MAKERWORLD_HOST_PATTERN.test(parsed.hostname)) return false;
    return MAKERWORLD_MODEL_PATH.test(parsed.pathname);
  } catch {
    return false;
  }
}

export function normalizeMakerworldUrl(raw) {
  const value = String(raw || '').trim();
  if (!value) return '';
  const withScheme = value.startsWith('http://') || value.startsWith('https://') ? value : `https://${value}`;
  return withScheme;
}
